import React from "react";
import { useTranslation } from "react-i18next";
import { CoinsIcon } from "lucide-react";

interface Props {
  credits: number;
}

export function CreditPreview({ credits }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex row items-center gap-2 border rounded-md p-2">
      <CoinsIcon className="w-4 h-4" />
      <span className="text-xs">
        {t("credits.message", { count: credits })}
      </span>
    </div>
  );
}
